import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider.jsx';
import { ProtectedRoute } from './auth/ProtectedRoute.jsx';
import { LoginPage } from './auth/LoginPage.jsx';
import { AppLayout } from './layout/AppLayout.jsx';
import { Dashboard } from './pages/Dashboard.jsx';
import { Sites } from './pages/Sites.jsx';
import { CreateSite } from './pages/CreateSite.jsx';
import { SiteDetail } from './pages/SiteDetail.jsx';
import { Servers } from './pages/Servers.jsx';
import { CloudServers } from './pages/CloudServers.jsx';
import { DnsManager } from './pages/DnsManager.jsx';
import { Storage } from './pages/Storage.jsx';
import { Tools } from './pages/Tools.jsx';
import { Integrations } from './pages/Integrations.jsx';
import { Users } from './pages/Users.jsx';
import { Audit } from './pages/Audit.jsx';

/**
 * Router skeleton:
 *   /login           → public LoginPage (redirects to `/` if already signed in)
 *   /                → protected AppLayout
 *     index          → Dashboard
 *     sites          → Sites
 *   *                → redirect to /
 */
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="sites" element={<Sites />} />
            <Route path="sites/new" element={<CreateSite />} />
            <Route path="sites/:domain" element={<SiteDetail />} />
            <Route path="servers" element={<Servers />} />
            <Route path="cloud" element={<CloudServers />} />
            <Route path="dns" element={<DnsManager />} />
            <Route path="storage" element={<Storage />} />
            <Route path="tools" element={<Tools />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="users" element={<Users />} />
            <Route path="audit" element={<Audit />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
